<template>
  <div :class="$style.bindPhone">
    <header>
      <i class="iconfont yw-xiangzuo" @click="$emit('close')" />
      <span>我的卡券</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="$emit('closePage')" :class="$style.closePage" />
    </header>
    <ul>
      <li v-for="(item, index) in voucherList" :key="index">
        <div :class="$style.info">
          <p :class="$style.name">{{ item.name }}</p>
          <p :class="$style.hint">{{ item.invalid_time }}到期</p>
        </div>
        <div v-if="item.type == 1" :class="$style.price">
          <p><span>￥</span><span>{{ item.off_money }}</span></p>
          <p :class="$style.hint">满{{ item.condition_money }}元可用</p>
        </div>
        <div v-else :class="$style.price">
          <p :class="$style.percent">{{ Number(item.percent) * 10 }}</p>
          <img :src="`${$cdnLink}/voucher/p_1.png`" alt="">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
    };
  },
  mounted() {
    this.setCache()
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
      voucherList: state => state.suspend.voucherList
    }),
  },
  methods: {
    setCache() {
      const voucherIds = this.$getStorage('voucherIds') || [];
      this.voucherList.map(item => {
        if (!voucherIds.includes(item.id)) {
          voucherIds.push(item.id)
        }
      })
      this.$setStorage('voucherIds', voucherIds);
    }
  },
};
</script>

<style lang="scss" module>
.bindPhone {
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  > header {
    position: relative;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    height: 40px;
    padding: 0 15px;
    color: #7a7979;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 20px;
    :global {
      .yw-xiangzuo {
        width: 15px;
        height: 15px;
        color: #7a7979;
      }
    }
    .closePage {
      height: 13px;
    }
  }
  > ul {
    > li {
      width: 332px;
      height: 65px;
      font-size: 16px;
      background: url('#{$cdn-url}/voucher/p_2.png') no-repeat;
      background-size: 100% 100%;
      display: block;
      margin: auto {
        bottom: 10px;
      };
      display: flex;
      align-items: center;
      .info {
        height: 100%;
        width: 250px;
        padding: 14px 0 0 21px;
        .name {
          font-size: 18px;
          color: #fc341f;
          margin-bottom: 10px;
        }
        .hint {
          font-size: 11px;
          color: #E47A50;
        }
      }
      .price {
        height: 100%;
        width: 80px;
        text-align: center;
        > p {
          margin-top: 15px;
          color: #ED0E00;
          font-size: 15px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          > span:nth-child(2) {
            display: inline-block;
            font-size: 20px;
          }
        }
        .percent {
          display: inline-block;
          margin-top: 20px;
          font-size: 28px;
        }
        > img {
          position: relative;
          width: 16px;
          height: 16px;
          top: 4px;
          left: -5px;
        }
        .hint {
          margin-top: 5px;
          font-size: 10px;
        }
      }
    }
  }
}
</style>
